/*
 * Bump Junip review carousel images to a higher resolution so they don't pixelate
 * inside the carousel wrappers on retina displays.
 * Junip can render images through Shopify CDN, Cloudinary, or lazy-load attributes.
 */
(function () {
  const TARGET_SIZE = 1080;
  const MIN_BUMP_RATIO = 1.5;
  const CAROUSEL_SELECTOR = '.wc-figma-review-carousel';
  const IMG_SELECTOR = '.junip-review-carousel-media-container img';
  const URL_ATTRIBUTES = ['src', 'srcset', 'data-src', 'data-srcset', 'data-original', 'data-lazy-src'];

  const upgradeUrlString = (url) => {
    if (typeof url !== 'string' || !url) return url;

    url = url.replace(/_(pico|icon|thumb|small|compact|medium|large|grande)(?=\.(?:jpe?g|png|webp|gif|avif))/gi, `_${TARGET_SIZE}x${TARGET_SIZE}`);

    url = url.replace(/_(\d{2,4})x(\d{0,4})(?:_crop_[a-z]+)?(?=\.(?:jpe?g|png|webp|gif|avif))/gi, (match, w, h) => {
      const wNum = parseInt(w, 10);
      if (wNum * MIN_BUMP_RATIO > TARGET_SIZE) return match;
      const newH = h ? String(TARGET_SIZE) : '';
      return `_${TARGET_SIZE}x${newH}`;
    });

    url = url.replace(/([,/])w_(\d{2,4})(?=[,/])/gi, (match, sep, width) => {
      const num = parseInt(width, 10);
      if (num * MIN_BUMP_RATIO > TARGET_SIZE) return match;
      return `${sep}w_${TARGET_SIZE}`;
    });

    url = url.replace(/([,/])h_(\d{2,4})(?=[,/])/gi, (match, sep, height) => {
      const num = parseInt(height, 10);
      if (num * MIN_BUMP_RATIO > TARGET_SIZE) return match;
      return `${sep}h_${TARGET_SIZE}`;
    });

    url = url.replace(/([?&])(width|w|h|size)=(\d{2,4})/gi, (match, sep, key, val) => {
      const num = parseInt(val, 10);
      if (num * MIN_BUMP_RATIO > TARGET_SIZE) return match;
      return `${sep}${key}=${TARGET_SIZE}`;
    });

    return url;
  };

  const upgradeSrcset = (srcset) => {
    if (typeof srcset !== 'string' || !srcset) return srcset;

    return srcset
      .split(',')
      .map((entry) => {
        const parts = entry.trim().split(/\s+/);
        parts[0] = upgradeUrlString(parts[0]);
        return parts.join(' ');
      })
      .join(', ');
  };

  const upgradeImage = (img) => {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.dataset.wcResolutionUpgraded === 'true') return;
    img.dataset.wcResolutionUpgraded = 'true';

    if (!img.sizes) {
      img.sizes = '(max-width: 749px) 320px, 280px';
    }

    URL_ATTRIBUTES.forEach((attribute) => {
      const value = img.getAttribute(attribute);
      if (!value) return;

      const next = attribute.toLowerCase().includes('srcset') ? upgradeSrcset(value) : upgradeUrlString(value);
      if (next !== value) img.setAttribute(attribute, next);
    });
  };

  const watchCarousel = (carousel) => {
    if (!(carousel instanceof HTMLElement)) return;
    if (carousel.dataset.wcImageQualityBound === 'true') return;
    carousel.dataset.wcImageQualityBound = 'true';

    carousel.querySelectorAll(IMG_SELECTOR).forEach(upgradeImage);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
          mutation.target.dataset.wcResolutionUpgraded = '';
          upgradeImage(mutation.target);
          continue;
        }
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches?.(IMG_SELECTOR)) upgradeImage(node);
          node.querySelectorAll?.(IMG_SELECTOR).forEach(upgradeImage);
        });
      }
    });

    observer.observe(carousel, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: URL_ATTRIBUTES,
    });
  };

  const init = () => {
    const existing = document.querySelectorAll(CAROUSEL_SELECTOR);
    if (existing.length) {
      existing.forEach(watchCarousel);
      return;
    }

    // Carousel block is injected by the Junip app after page load — wait for it.
    const bootstrap = new MutationObserver(() => {
      const carousels = document.querySelectorAll(CAROUSEL_SELECTOR);
      if (!carousels.length) return;
      bootstrap.disconnect();
      carousels.forEach(watchCarousel);
    });
    bootstrap.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
